import { ParsedUrlQuery } from 'querystring';

const saleQueryParams: ParsedUrlQuery = {
    price_frequency: 'per_month',
    results_sort: 'newest_listings',
    new_homes: 'include',
    retirement_homes: 'true',
    shared_ownership: 'true',
    include_auctions: 'true',
    include_shared_accommodation: 'true',
    search_source: 'for-sale',
    section: 'for-sale',
    view_type: 'list'
};

const rentQueryParams: ParsedUrlQuery = {
    price_frequency: 'per_month',
    results_sort: 'newest_listings',
    retirement_homes: 'true',
    include_auctions: 'true',
    include_shared_accommodation: 'true',
    search_source: 'to-rent',
    section: 'to-rent',
    view_type: 'list'
};

const homeQueryParams: ParsedUrlQuery = {
    price_frequency: 'per_month',
    results_sort: 'recommended',
    new_homes: 'only',
    retirement_homes: 'false',
    shared_ownership: 'true',
    include_auctions: 'false',
    include_shared_accommodation: 'false',
    search_source: 'new-homes',
    section: 'new-homes',
    view_type: 'list'
};

type SearchType =
    | 'to-rent'
    | 'for-sale'
    | 'new-homes'
    | 'house-prices'
    | 'home-values';

export function getQueryParams(type: SearchType) {
    const searchTypeQueryParams = {
        'to-rent': rentQueryParams,
        'for-sale': saleQueryParams,
        'new-homes': homeQueryParams,
        'house-prices': null,
        'home-values': null
    };

    return searchTypeQueryParams[type];
}
